import { Component, OnInit, Input, Inject, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LoggerService } from '@wdpr/ra-angular-logger';
import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { CUSTOM_EVENTS } from '@finder/shared/constants/custom-events.constants';
import { AriaLabelHtmlDirective } from '@finder/shared/directives/aria-label-html/aria-label-html.directive';
import { LocaleDirective } from '@finder/shared/directives/locale/locale.directive';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';
import { ButtonComponent } from '@finder/shared/components/button/button.component';
import { ScheduleInfoComponent } from '../schedule-info/schedule-info.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';

@Component({
    selector: 'finder-info-bar',
    templateUrl: './info-bar.component.html',
    styleUrls: ['./info-bar.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        AriaLabelHtmlDirective,
        LocaleDirective,
        LinkIdDirective,
        ButtonComponent,
        FontIconComponent,
        ScheduleInfoComponent,
    ]
})
export class InfoBarComponent implements OnInit, OnDestroy {
    @Input() infoBarData: any;

    @ViewChild('scheduleInfo', { read: ElementRef }) scheduleInfo: ElementRef;
    @ViewChild('scheduleSection', { read: ElementRef }) scheduleSection: ElementRef;

    location: any;
    schedule: any = {};
    map: any;
    button: any;
    isDesktop = false;
    private destroy$ = new Subject<void>();

    constructor(
        private window: WindowRef,
        private logger: LoggerService,
        private viewport: ViewportDetectionService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        if (isEmpty(this.infoBarData)) {
            this.logger.error(`Error - Invalid info bar data!`);

            return;
        }
        this.isDesktop = this.viewport.isDesktop();
        this.viewport.onViewportResize().pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.isDesktop = this.viewport.isDesktop();
        });
        this.location = this.infoBarData.location;
        this.schedule = this.infoBarData.schedule;
        this.map = this.infoBarData.map;
        this.button = this.infoBarData.button;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    show(event) {
        const hasSchedule = get(this.infoBarData, 'schedule.hasSchedule', false);

        /* If we have schedules then we prevent the link from redirecting to the /calendars page
         * and we open the calendar instead.
         */
        if (hasSchedule) {
            event.preventDefault();
            event.stopPropagation();
            this.schedule.open = !this.schedule.open;
        }
    }

    closeScheduleInfo() {
        // On escape keyup, we close/hide the schedule info component.
        this.schedule.open = false;
        this.scheduleSection.nativeElement.focus();
    }

    // Spent WAY longer on this than would have liked and for what really? It is all DOM stuff
    // that we don't really need to test (hint: it works). I guess we could make sure of the
    // selector used, but ¯\_(ツ)_/¯
    /* istanbul ignore next */
    scroll(event) {

        // Prevent the map link from redirecting to the home page.
        event.preventDefault();
        event.stopPropagation();

        const mapEl: HTMLElement = this.document.querySelector('.finder-map-container');
        mapEl.scrollIntoView({behavior: 'smooth'});
        mapEl.focus();

        // check to see if we're on the star wars page and trigger the cloud up event
        this.document.querySelectorAll(`body.swge-theme`).forEach(() => {
            this.document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TRIGGER_METHOD, {
                detail: {
                    method: 'showCloudAnimation'
                }
            }));
        });
    }

    focusScheduleInfoElement() {
        this.scheduleInfo.nativeElement.focus();
    }
}
